import React, { Component } from "react";

import { Helmet } from "react-helmet";
import NotFoundBlock from "components/NotFoundBlock/NotFoundBlock";
import headerPhoto from "assets/images/Assortiment/01_Headerfoto/FPG101.jpg";

export default class NotFound extends Component {
  componentDidMount() {
    document.body.classList.add("404-page");
  }
  componentWillUnmount() {
    document.body.classList.remove("404-page");
  }
  render() {
    return [
      <Helmet key="head">
        <meta charSet="utf-8" />
        <title>404 | Forever Plants</title>
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SAFE_URL}${headerPhoto}`}
        />
      </Helmet>,
      <span className="parallax-logo404" key="logo" />,
      <div className="wrapper" id="pageWrapper" key="content">
        <NotFoundBlock />
      </div>,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/Pages/NotFound.jsx